import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api.ts'
import { useAuthStore } from '@/stores/auth.ts'

/**
 * Checks whether the current user has a specific permission.
 * Uses the backend's merged permission logic (role default → DB override → user override).
 * Admins always return true without a server round-trip.
 */
export function usePermission(resource: string, action: string): { allowed: boolean; isLoading: boolean } {
  const user = useAuthStore((s) => s.user)
  const isAdmin = user?.role === 'admin'

  const { data, isLoading } = useQuery<{ allowed: boolean }>({
    queryKey: ['permission-check', user?.id, resource, action],
    queryFn: () =>
      apiClient
        .get('/permissions/check', { params: { resource, action } })
        .then((r) => r.data),
    enabled: !!user && !isAdmin,
    staleTime: 60_000,
  })

  if (isAdmin) return { allowed: true, isLoading: false }
  return { allowed: data?.allowed ?? false, isLoading }
}
